module.exports = __webpack_public_path__ + "img/Porsche.b62137b5.png";